export default "__VITE_ASSET__DdTRJO4l__"